import React, { useState } from 'react';
import './ChatIA.css';

function ChatIA() {
  const [isOpen, setIsOpen] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [historial, setHistorial] = useState([
    { sender: 'bot', text: '¡Hola! Soy el asistente de Bambo Eventos. 🐼🎧 ¿En qué te puedo ayudar hoy? ¿Necesitas cotizar o averiguar precios u horarios?' }
  ]);
  // Estado para controlar los 3 puntitos cargando
  const [cargando, setCargando] = useState(false);

  // Función auxiliar para pausar la ejecución (mantiene los puntitos bailando de forma estática)
  const esperarSegundos = (segundos) => new Promise(resolve => setTimeout(resolve, segundos * 1000));

  const enviarMensaje = async (e) => {
    if (e) e.preventDefault(); // Evita recargar la página en el envío inicial
    if (!mensaje.trim() || cargando) return;

    const mensajeUsuarioActual = mensaje; 
    
    // Mostramos inmediatamente el mensaje del usuario en el historial
    const nuevoHistorial = [...historial, { sender: 'user', text: mensajeUsuarioActual }];
    setHistorial(nuevoHistorial);
    setMensaje('');
    
    setCargando(true); // ⏱️ Los tres puntos se encienden y se mantienen activos

    let peticionExitosa = false;
    let tiempoEsperaFrontend = 30; // Primer bloqueo espera de golpe 30 segundos

    while (!peticionExitosa) {
      try {
        // Enviar consulta al backend
        const response = await fetch('https://backend-bambos.onrender.com/api/chat-publico/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ mensaje: mensajeUsuarioActual }),
        });

        // 🔥 SI DJANGO RETORNA BLOQUEO POR LÍMITE DE TIEMPO (HTTP 429)
        if (response.status === 429) {
          console.log(`⏱️ Cooldown activo. Manteniendo puntitos y simulando espera interna de ${tiempoEsperaFrontend}s en Frontend...`);
          
          // Duerme el proceso en el navegador sin enviar peticiones repetitivas al servidor
          await esperarSegundos(tiempoEsperaFrontend); 

          // Si el cooldown persiste en la siguiente vuelta, reduce la espera a ráfagas de 10 segundos
          tiempoEsperaFrontend = 10; 
          continue; // Regresa al inicio del bucle `while` para volver a verificar de manera segura
        }

        // Si la respuesta es HTTP 200, procesamos el JSON de la IA
        const data = await response.json();

        if (data.error) {
          setHistorial(prev => [
            ...prev,
            { sender: 'bot', text: `❌ Error del sistema: ${data.error}` }
          ]);
        } else {
          setHistorial(prev => [
            ...prev, 
            { sender: 'bot', text: data.respuesta, urlPago: data.url_pago }
          ]);
        }
        
        peticionExitosa = true; // Finaliza el bucle exitosamente 🎉

      } catch (error) {
        console.error("Error conectando con la IA:", error);
        setHistorial(prev => [
          ...prev, 
          { sender: 'bot', text: 'Ocurrió un problema de conexión. Asegúrate de que el backend de Django esté encendido.' }
        ]);
        peticionExitosa = true; // Rompe el bucle ante una falla crítica de red (como el servidor caído)
      }
    }

    setCargando(false); // 🔥 Los puntos SOLO se apagan cuando la respuesta real ya se va a pintar en pantalla
  };

  return (
    <div className="chat-ia-container">
      {isOpen && (
        <div className="chat-window animate__animated animate__fadeInUp">
          <div className="chat-header">
            <h4>Bambo Asistente 🤖</h4>
            <button onClick={() => setIsOpen(false)} className="close-btn">×</button>
          </div>
          
          <div className="chat-body">
            {historial.map((msg, index) => (
              <div key={index} className={`chat-message ${msg.sender}`}>
                <p>{msg.text}</p>
                
                {msg.urlPago && (
                  <a 
                    href={msg.urlPago} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn-pago-rapido"
                    style={{
                      display: 'block',
                      marginTop: '10px',
                      padding: '10px',
                      background: '#ffc107', 
                      color: '#000',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      borderRadius: '6px',
                      textDecoration: 'none',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.15)',
                      transition: 'background 0.3s ease',
                      fontSize: '13px'
                    }}
                  >
                    🎯 Haz clic aquí para registrar tu dirección y continuar con tu pago
                  </a>
                )}
              </div>
            ))}

            {/* 🔥 BURBUJA DE ANIMACIÓN CONTINUA */}
            {cargando && (
              <div className="chat-message bot typing-container">
                <div className="typing-bubble">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
              </div>
            )}
          </div>

          <form onSubmit={enviarMensaje} className="chat-footer">
            <input 
              type="text" 
              placeholder={cargando ? "Panda DJ preparando respuesta..." : "Escribe tu duda o cuántas horas buscas..."}
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              disabled={cargando}
            />
            <button type="submit" disabled={cargando}>
              <i className="bi bi-send-fill"></i>
            </button>
          </form>
        </div>
      )}

      {!isOpen && (
        <div className="panda-trigger" onClick={() => setIsOpen(true)}>
          <div className="speech-bubble-panda">
            ¡¿Tienes dudas?! <br /> Presiona AQUÍ para ayudarte
          </div>
          <img 
            src="/img/PandaIA_ACT.png"
            alt="Panda DJ Asistente" 
            className="panda-avatar-img"
          />
        </div>
      )}
    </div>
  );
}

export default ChatIA;